import { render, staticRenderFns } from "./scope-container.vue?vue&type=template&id=1199a57a&"
import script from "./scope-container.vue?vue&type=script&lang=tsx&"
export * from "./scope-container.vue?vue&type=script&lang=tsx&"
import style0 from "./scope-container.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports